<div class="agpr-topMentionsMad">
    @if (!hasSentimentDropdown) {
        <h4 class="agpr-topMentionsMad-heading">
            <span class="agpr-topMentionsMad-titleText"> {{ 'Monitor.MAD.topMentions.title' | localize }} {{ 'Monitor.MAD.topMentions.title2' | localize }} </span>
            <agpr-dropdown
                class="agpr-topMentionsMad-heading-dropdown"
                [style]="dropdownTypes.borderless"
                [agprStyle]="agprComponentStyles.social"
                [options]="metricOptions"
                [(ngModel)]="selectedMetric"
                (ngModelChange)="metricChange($event.value)"
            ></agpr-dropdown>
        </h4>
    }

    @else {
        <h4 class="agpr-topMentionsMad-heading">
            <span class="agpr-topMentionsMad-titleText"> {{ 'Monitor.MAD.topMentions.title' | localize }}</span>
            <agpr-dropdown
                class="agpr-topMentionsMad-heading-dropdown"
                [style]="dropdownTypes.borderless"
                [agprStyle]="agprComponentStyles.social"
                [options]="sentimentOptions"
                [(ngModel)]="selectedSentiment"
                (ngModelChange)="sentimentChange($event.value)"
            ></agpr-dropdown>
            <span class="agpr-topMentionsMad-titleText"> {{ 'Monitor.MAD.topMentions.title2' | localize }}</span>
            <agpr-dropdown
                class="agpr-topMentionsMad-heading-dropdown"
                [style]="dropdownTypes.borderless"
                [agprStyle]="agprComponentStyles.social"
                [options]="metricOptions"
                [(ngModel)]="selectedMetric"
                (ngModelChange)="metricChange($event.value)"
            ></agpr-dropdown>
        </h4>
    }

    <div class="agpr-topMentionsMad-mentions" [agprLoading]="!mentions" [agprInlineLoadingIndicator]="true">
        <ul
            [id]="id + '_mentionList'"
            agprListKeyboardNavigation
            [list]="mentions"
            class="agpr-topMentionsMad-mentionsWrapper"
        >
            <li
                *ngFor="let mention of mentions; index as i"
                class="agpr-topMentionsMad-mention"
                [attr.aria-label]="mention.headline ?
                    mention.headline :
                    ('MediaType.'+ mention.mediaType.id | localize) +  ('Mention.postBy' | localize) +  mention.author.name
                "
                (agprClickUnless)="mentionCardClicked({ eventType: 'mention', mention: mention })"
                [agprClickUnlessSelectors]="['a', 'button', 'input', 'agpr-checkbox']"
            >
                <agpr-mention-card
                    #mentionCard
                    [id]="id + '_mention'"
                    [mention]="mention"
                    [mentionContent]="mentionContentTypes.headlineOnly"
                    [metricType]="sortField"
                    (contactClicked)="mentionCardClicked({ eventType: 'contact', mention: mention })"
                    (outletClicked)="mentionCardClicked({ eventType: 'outlet', mention: mention })"
                    [showSentimentOnExpanded]="false"
                ></agpr-mention-card>
                <div
                    class="agpr-topMentionsMad-icons agpr-topMentionsMad-icons--right agpr-contextMenu top right"
                    [id]="id"
                >
                    <agpr-button
                        class="agpr-topMentionsMad-icon agpr-topMentionsMad-icon--topRight agpr-topMentionsMad-gearIcon"
                        [style]="buttonTypesEnum.contextMenu"
                        icon="fa-regular fa-duotone fa-gear"
                        agprTooltip="Mention.manageMentionOrganization.gearIcon.tooltip"
                        tooltipPosition="left"
                        (click)="openManageMentionOrganizationDialog(mention, $event)"
                    ></agpr-button>
                    @if(openAiPermission &&
                        !mention.isTranslatedPreferred &&
                        !mention.isFinancialTimes &&
                        showTranslate &&
                        mention?.languageModel?.name &&
                        ((mention?.languageModel?.name | localize) !== userLanguage)) {
                        <agpr-button
                            [id]="'quick-translate' + mention?.id"
                            [icon]="mention.translating ? '' : 'fa-kit-duotone fa-agpr-translate'"
                            [style]="buttonTypesEnum.contextMenu"
                            class="agpr-topMentionsMad-icon agpr-topMentionsMad-icon--topRight"
                            [disabled]="concurrentTranslation >= maxConcurrentTranslation"
                            [ngClass]="{
                                'agpr-topMentionsMad-icon-show': mention.translating
                            }"
                            [tooltip]="(concurrentTranslation >= maxConcurrentTranslation) ?
                                ('Mention.translate.tooManyRequests' | localize : {
                                    max : maxConcurrentTranslation
                                }) :
                                ('Mention.translateTo' | localize: {
                                    language: mention?.showTranslated ? ('Language.' + mention?.language | localize) : userLanguage
                                })
                            "
                            tooltipPosition="top"
                            (click)="mention?.showTranslated ? revertTranslate(mention) : translate(mention)"
                            [loading]="mention.translating"
                        >
                        </agpr-button>
                    }
                </div>

            </li>
        </ul>
        @if (mentions && mentions.length === 0) {
            <div
                class="agpr-topMentionsMad-noContent"
            >
                <agpr-message
                    [severity]="messageSeverities.noContent"
                    [style]="agprComponentStyles.social"
                >
                    {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                </agpr-message>
            </div>
        }

        <agpr-button
            class="agpr-topMentionsMad-viewAllButton"
            label="viewAll"
            [style]="buttonTypesEnum.tertiary"
            (click)="viewAll()"
        ></agpr-button>
    </div>
</div>
